import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Class representing a view for the record table agent list.
 * @extends JetView
 */
export default class recordTableAgentListView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const vthis = this; // Reference to the current instance

        // Window for advanced filter details
        const filterDetails = webix.ui({
            view: 'window',
            move: true,
            id: 'filterDetails',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Detalles Avanzados'), // Advanced details label
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the window on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'datatable',
                id: 'dtDetails', // DataTable for detailed view
                css: 'webix_header_border webix_data_border webix_footer_border',
                select: true,
                columns: [
                    {
                        id: 'Date',
                        header: _('Fecha'), // Date column header
                        width: 150,
                        sort: 'int',
                    },
                    {
                        id: 'TypeQuota',
                        header: _('Tipo Cupo'), // Quota type column header
                        editor: 'combo',
                        options: [
                            { id: 'A', value: _('Apuestas') }, // Bet option
                            { id: 'R', value: _('Recargas') }, // Recharge option
                        ],
                        width: 100,
                        sort: 'int',
                    },
                    {
                        id: 'TypeTransaction',
                        header: _('Tipo Transacción'), // Transaction type column header
                        editor: 'combo',
                        options: [
                            { id: 'E', value: _('Deposito') }, // Deposit option
                            { id: 'S', value: _('Salida') }, // Withdrawal option
                        ],
                        width: 150,
                        sort: 'int',
                    },
                    {
                        id: 'Amount',
                        header: _('Valor'), // Amount column header
                        format: webix.i18n.priceFormat, // Formatting for price
                        exportType: 'number',
                        width: 100,
                        sort: 'int',
                    },
                    {
                        id: 'Currency',
                        header: _('Moneda'), // Currency column header
                        width: 100,
                        sort: 'int',
                    },
                    {
                        id: 'Assigned',
                        header: _('Asignado Por'), // Assigned by column header
                        width: 200,
                        sort: 'int',
                    },
                ],
                pager: 'pagerA', // Pager for the datatable
            },
        });

        // Main datatable configuration
        return {
            view: 'datatable',
            id: 'datatable', // Main datatable ID
            css: 'webix_header_border webix_data_border webix_footer_border',
            select: true,
            columns: [
                {
                    id: 'Date',
                    header: _('Fecha'), // Date column header
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'TypeQuota',
                    header: _('Tipo Cupo'), // Quota type column header
                    editor: 'combo',
                    options: [
                        { id: 'A', value: _('Apuestas') }, // Bet option
                        { id: 'R', value: _('Recargas') }, // Recharge option
                    ],
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'TypeTransaction',
                    header: _('Tipo Transacción'), // Transaction type column header
                    editor: 'combo',
                    options: [
                        { id: 'E', value: _('Deposito') }, // Deposit option
                        { id: 'S', value: _('Salida') }, // Withdrawal option
                    ],
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'Amount',
                    header: _('Valor'), // Amount column header
                    format: webix.i18n.priceFormat, // Formatting for price
                    exportType: 'number',
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'Currency',
                    header: _('Moneda'), // Currency column header
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'Assigned',
                    header: _('Asignado Por'), // Assigned by column header
                    width: 200,
                    sort: 'int',
                },
            ],
            pager: 'pagerA', // Pager for the datatable
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The main datatable instance.
     */
    init(grid) {
        var url = devConfig.geturlApi() + 'es/Agent/AssignmentQuota'; // API endpoint for assignment quota
        this.on(this.app, 'assignmentQuota:id', (Id) => {
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?id=' + Id); // Load new data based on ID
            $$('dtDetails').clearAll(); // Clear detailed datatable
            $$('dtDetails').load(url + '?id=' + Id); // Load detailed data based on ID
        });
    }
}

// FILE DOCUMENTED
